export const DEFAULT_RADIOLOGIST_TEXT = 'DEFAULT';

export const shouldApplyHallDefaultRadiologist = (
    currentRadiologistUid?: string | null,
    currentRadiologistText?: string | null,
): boolean => {
    const radiologistUid = currentRadiologistUid?.trim() ?? '';
    const radiologistText = currentRadiologistText?.trim() ?? '';

    return (!radiologistUid && !radiologistText)
        || radiologistText.toUpperCase() === DEFAULT_RADIOLOGIST_TEXT;
};
